import { FC, useEffect, useState } from 'react'
import classNames from 'classnames'
import { Header, Footer, NavSidebar, NavigationItem } from '..'
import {
  ChevronRightIcon,
  HomeIcon,
  MapPinIcon,
  FolderIcon,
  EnvelopeIcon,
  InboxStackIcon,
  PencilSquareIcon,
  PaperAirplaneIcon,
  ClipboardDocumentListIcon,
  TruckIcon,
  CogIcon,
  CubeIcon,
  TableCellsIcon,
  ChartBarSquareIcon,
  InboxArrowDownIcon,
  DocumentChartBarIcon,
  ArrowUpOnSquareIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline'
import { useAppSelector } from '../../store/hooks'
import { GetModuleByUser } from '../../services'

const iconMap: any = {
  HomeIcon: HomeIcon,
  EnvelopeIcon: EnvelopeIcon,
  PaperAirplaneIcon: PaperAirplaneIcon,
  FolderIcon: FolderIcon,
  PencilSquareIcon: PencilSquareIcon,
  MapPinIcon: MapPinIcon,
  InboxStackIcon: InboxStackIcon,
  ClipboardDocumentListIcon: ClipboardDocumentListIcon,
  TruckIcon: TruckIcon,
  Cog: CogIcon,
  Table: TableCellsIcon,
  Cube: CubeIcon,
  ChartBarSquare: ChartBarSquareIcon,
  InboxArrowDown: InboxArrowDownIcon,
  DocumentChartBar: DocumentChartBarIcon,
  ArrowUpOnSquare: ArrowUpOnSquareIcon,
  DocumentText: DocumentTextIcon,
}

const EmptyIcon = () => null

interface MainPageProps {
  children?: React.ReactNode
}
const SIDEBAR_COLLAPSED_KEY = 'nav.sidebarCollapsed'

export const MainPage: FC<MainPageProps> = ({ children }) => {
  const user = useAppSelector((state) => state.user)
  const [navigation2, setNavigation2] = useState<NavigationItem[]>([])

  // Preferencia de menú oculto/mostrado (desktop). Persistida para que se
  // mantenga al navegar entre páginas (MainPage se re-monta por ruta).
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
    } catch {
      return false
    }
  })

  const toggleSidebar = () =>
    setSidebarCollapsed((prev) => {
      const next = !prev
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? '1' : '0')
      } catch {
        /* almacenamiento no disponible: se ignora */
      }
      return next
    })

  useEffect(() => {
    async function GetModuleUser() {
      const result: NavigationItem[] = await GetModuleByUser(
        user.user?.id,
        user.user?.profileID
      )

      // // TODO: Remove this manual entry once added to backend
      // result.push({
      //   name: 'Reporte de Guías',
      //   href: '/reports/guides',
      //   icon: 'DocumentChartBar',
      //   iconRender: EmptyIcon,
      //   children: [],
      // })

      result.forEach((item) => {
        const iconComponent = iconMap[item.icon as string]
        item.iconRender = iconComponent ?? EmptyIcon
      })
      setNavigation2(result)
    }
    GetModuleUser()
  }, [])

  return (
    <main
      className="flex flex-col w-full h-full"
      style={{ minHeight: '100vh' }}
    >
      <div>
        <Header
          onToggleSidebar={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
        />
      </div>

      <div
        className={classNames(
          'relative flex flex-1 lg:pr-4 pl-12 pt-16 lg:pt-0 transition-[padding] duration-300 ease-in-out',
          sidebarCollapsed ? 'lg:pl-0' : 'lg:pl-64'
        )}
      >
        <NavSidebar navigation={navigation2} collapsed={sidebarCollapsed} />

        {/* Botón flotante para reabrir el menú: solo desktop y solo cuando está oculto */}
        {sidebarCollapsed && (
          <button
            type="button"
            onClick={toggleSidebar}
            title="Mostrar menú"
            aria-label="Mostrar menú"
            className="fixed left-2 top-2/3 z-30 hidden h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-gray-200 bg-white text-main-500 shadow-md transition hover:scale-105 hover:bg-gray-50 lg:flex"
          >
            <ChevronRightIcon className="h-5 w-5" />
          </button>
        )}

        <div className="px-4 py-6 w-full">{children}</div>
      </div>

      <div className="mt-auto z-10">
        <Footer />
      </div>
    </main>
  )
}
